export const downloadFile = (name: string, url: string): void => {
  const link = document.createElement('a');

  link.download = name;
  link.href = url;
  link.target = '_blank';
  link.click();
  link.remove();
};
